import * as firebase from "firebase";
import * as React from "react";

import { withRouter } from "react-router-dom";
import { compose } from "recompose";

import Firebase, { withFirebase } from "../../Firebase";

import * as ROUTES from "../../constants/routes";

interface IProps {
  firebase: Firebase;
  history: any;
}

const withAuthorization = (condition: any) => (Component: any) => {
  class WithAuthorization extends React.Component<IProps, any> {
    private listener: firebase.Unsubscribe;

    public componentDidMount(): void {
      this.listener = this.props.firebase.auth.onAuthStateChanged(
        (u: firebase.User | null) => {
          if (!condition(u)) {
            this.props.history.push(ROUTES.SIGN_IN);
          }
        }
      );
    }

    public componentWillUnmount(): void {
      this.listener();
    }

    public render() {
      return <Component {...this.props} />;
    }
  }

  return compose(
    withRouter,
    withFirebase
  )(WithAuthorization);
};

export default withAuthorization;



// WEBPACK FOOTER //
// ./src/components/Session/withAuthorization.tsx